<script setup lang="ts">
import { STATUS_DOT_CLASSES, type StatusTone } from './status-tone';

const { tone = 'neutral', color = null } = defineProps<{
  tone?: StatusTone;
  /** Цвет из БД, который выбрал оператор; важнее тона. */
  color?: string | null;
}>();
</script>

<template>
  <span
    class="inline-flex max-w-full items-center gap-1.5 rounded-full bg-(--base-element-color) px-2.5 py-1 text-xs font-medium text-(--base-text-color)"
  >
    <!-- Цвет выбирает оператор и хранит БД: единственное допустимое inline-значение. -->
    <span
      aria-hidden="true"
      class="h-2 w-2 shrink-0 rounded-full"
      :class="STATUS_DOT_CLASSES[tone]"
      :style="{ backgroundColor: color ?? undefined }"
    />
    <span class="truncate"><slot /></span>
  </span>
</template>
